import React, { useEffect, useRef, useState } from 'react';
import { Badge } from './ui/badge';
import { cn } from '../lib/utils';

const GlobeVisualization = ({ vesselData, layers }) => {
  const canvasRef = useRef(null);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  // More realistic world map coordinates with detailed coastlines
  const worldMap = {
    continents: [
      // North America (more detailed)
      [[70, -170], [71, -156], [70, -141], [69, -137], [60, -141], [58, -137], [56, -130], [54, -132], [52, -128], [50, -125], [48, -123], [45, -124], [42, -124], [40, -124], [32, -117], [32, -115], [31, -114], [25, -97], [26, -97], [29, -95], [29, -90], [30, -88], [29, -84], [26, -80], [25, -80], [24, -81], [25, -84], [28, -90], [30, -94], [33, -97], [36, -97], [37, -96], [39, -95], [41, -95], [42, -87], [43, -82], [44, -79], [45, -74], [47, -69], [47, -67], [46, -64], [45, -64], [44, -66], [43, -66], [41, -71], [41, -73], [42, -75], [43, -79], [45, -80], [48, -84], [49, -89], [50, -95], [52, -102], [53, -110], [54, -114], [55, -120], [56, -125], [58, -133], [59, -135], [60, -139], [62, -141], [65, -144], [67, -148], [68, -156], [70, -163], [70, -170]],
      
      // South America (more detailed)
      [[12, -71], [11, -72], [10, -73], [8, -77], [4, -78], [2, -79], [0, -79], [-2, -80], [-5, -81], [-9, -78], [-12, -77], [-14, -76], [-16, -73], [-18, -70], [-20, -70], [-23, -70], [-26, -70], [-30, -71], [-33, -71], [-36, -73], [-40, -73], [-43, -74], [-46, -74], [-50, -74], [-52, -71], [-53, -69], [-54, -68], [-55, -67], [-54, -65], [-52, -64], [-50, -69], [-46, -68], [-43, -65], [-40, -63], [-37, -61], [-34, -57], [-32, -55], [-30, -53], [-28, -51], [-26, -49], [-22, -47], [-20, -45], [-18, -43], [-16, -44], [-14, -45], [-12, -45], [-10, -46], [-8, -48], [-6, -49], [-4, -50], [-2, -51], [0, -51], [2, -52], [4, -53], [5, -55], [6, -58], [7, -60], [8, -62], [9, -65], [10, -67], [11, -69], [12, -71]],
      
      // Europe (more detailed)
      [[71, 25], [70, 28], [69, 30], [68, 33], [66, 35], [64, 28], [62, 25], [60, 24], [59, 22], [58, 19], [57, 17], [56, 10], [55, 8], [54, 9], [53, 10], [52, 5], [51, 4], [50, 2], [49, -1], [48, -4], [47, -5], [46, -2], [45, 1], [44, 3], [43, 5], [42, 8], [41, 11], [40, 14], [39, 18], [38, 22], [37, 25], [36, 27], [37, 29], [38, 30], [40, 28], [42, 26], [44, 25], [46, 24], [48, 23], [50, 24], [52, 26], [54, 28], [56, 30], [58, 31], [60, 30], [62, 29], [64, 30], [66, 32], [68, 35], [70, 35], [71, 32], [71, 25]],
      
      // Africa (more detailed)
      [[37, -6], [36, -1], [35, 3], [34, 10], [32, 15], [31, 20], [30, 25], [28, 30], [25, 33], [22, 35], [18, 38], [15, 40], [12, 42], [10, 43], [8, 45], [5, 47], [3, 48], [0, 49], [-3, 50], [-6, 50], [-9, 50], [-12, 49], [-15, 48], [-18, 46], [-20, 44], [-22, 42], [-24, 40], [-26, 38], [-28, 35], [-30, 32], [-32, 29], [-34, 26], [-35, 23], [-34, 20], [-33, 17], [-32, 15], [-30, 12], [-28, 10], [-26, 11], [-24, 13], [-22, 15], [-20, 17], [-18, 19], [-15, 20], [-12, 21], [-10, 22], [-8, 23], [-6, 24], [-4, 25], [-2, 26], [0, 27], [2, 28], [4, 29], [6, 30], [8, 31], [10, 31], [12, 30], [14, 29], [16, 28], [18, 27], [20, 26], [22, 24], [24, 22], [26, 20], [28, 18], [30, 15], [32, 12], [34, 9], [35, 5], [36, 0], [37, -6]],
      
      // Asia (more detailed)
      [[77, 68], [76, 74], [75, 82], [74, 90], [73, 100], [71, 110], [70, 120], [68, 130], [66, 140], [64, 145], [62, 150], [60, 155], [58, 157], [55, 158], [52, 156], [50, 152], [48, 148], [46, 145], [44, 142], [42, 140], [40, 138], [38, 136], [35, 135], [32, 134], [30, 133], [28, 132], [25, 130], [23, 128], [20, 125], [18, 122], [16, 120], [14, 118], [12, 116], [10, 114], [8, 112], [6, 110], [5, 108], [4, 105], [5, 103], [7, 100], [9, 97], [11, 95], [13, 92], [15, 90], [17, 88], [19, 85], [21, 83], [23, 81], [25, 79], [27, 77], [29, 75], [31, 73], [33, 71], [35, 69], [37, 67], [39, 65], [41, 63], [43, 61], [45, 60], [47, 58], [49, 56], [51, 55], [53, 54], [55, 53], [57, 52], [59, 51], [61, 50], [63, 49], [65, 50], [67, 52], [69, 54], [71, 56], [73, 58], [75, 62], [76, 65], [77, 68]],
      
      // Australia (more detailed)
      [[-10, 113], [-11, 114], [-12, 115], [-13, 116], [-15, 118], [-17, 121], [-19, 123], [-21, 125], [-23, 127], [-25, 128], [-27, 129], [-29, 130], [-31, 131], [-33, 132], [-35, 133], [-37, 134], [-38, 136], [-39, 138], [-38, 140], [-37, 142], [-36, 144], [-35, 146], [-33, 148], [-32, 150], [-31, 152], [-29, 153], [-27, 153], [-25, 153], [-23, 153], [-21, 152], [-19, 151], [-17, 150], [-15, 149], [-13, 148], [-11, 146], [-10, 144], [-9, 142], [-10, 140], [-11, 138], [-11, 136], [-11, 134], [-11, 132], [-11, 130], [-11, 128], [-11, 126], [-11, 124], [-11, 122], [-11, 120], [-11, 118], [-11, 116], [-10, 114], [-10, 113]],
      
      // Greenland
      [[83, -35], [83, -32], [82, -28], [81, -25], [80, -22], [78, -20], [76, -19], [74, -20], [72, -22], [70, -24], [68, -27], [66, -30], [65, -33], [64, -36], [63, -40], [62, -43], [61, -46], [60, -50], [61, -52], [62, -50], [63, -48], [65, -45], [67, -42], [69, -40], [71, -38], [73, -37], [75, -36], [77, -35], [79, -34], [81, -34], [83, -35]],
      
      // New Zealand
      [[-34, 172], [-35, 173], [-37, 174], [-39, 174], [-41, 174], [-43, 173], [-45, 172], [-46, 170], [-46, 168], [-45, 167], [-43, 167], [-41, 168], [-39, 169], [-37, 170], [-35, 171], [-34, 172]],
      
      // Japan
      [[45, 141], [43, 142], [41, 142], [39, 141], [37, 140], [35, 139], [34, 137], [33, 135], [32, 133], [31, 132], [32, 131], [33, 130], [34, 131], [35, 132], [36, 133], [38, 135], [40, 137], [42, 139], [44, 140], [45, 141]],
      
      // Madagascar
      [[-12, 49], [-13, 50], [-15, 50], [-17, 50], [-19, 50], [-21, 49], [-23, 48], [-25, 47], [-25, 45], [-24, 44], [-22, 44], [-20, 44], [-18, 44], [-16, 45], [-14, 46], [-12, 48], [-12, 49]],
    ]
  };

  // Convert lat/lon to 3D sphere coordinates
  const latLonToXY = (lat, lon, centerX, centerY, radius, rotX, rotY) => {
    const latRad = (lat * Math.PI) / 180;
    const lonRad = ((lon + rotY) * Math.PI) / 180;
    
    const x = radius * Math.cos(latRad) * Math.sin(lonRad);
    const y = radius * Math.sin(latRad);
    const z = radius * Math.cos(latRad) * Math.cos(lonRad);
    
    // Simple 3D projection
    const scale = 1 / (1 + z / (radius * 3));
    return {
      x: centerX + x * scale,
      y: centerY - y * scale,
      visible: z > -radius * 0.3 // Only show front hemisphere
    };
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const width = canvas.width = canvas.offsetWidth * 2;
    const height = canvas.height = canvas.offsetHeight * 2;
    ctx.scale(2, 2);

    const centerX = width / 4;
    const centerY = height / 4;
    const radius = Math.min(width, height) / 4.5;

    const drawGlobe = () => {
      ctx.clearRect(0, 0, width / 2, height / 2);

      // Background gradient
      const bgGradient = ctx.createRadialGradient(centerX, centerY - 50, 0, centerX, centerY, radius * 1.5);
      bgGradient.addColorStop(0, 'rgba(55, 211, 255, 0.08)');
      bgGradient.addColorStop(1, 'transparent');
      ctx.fillStyle = bgGradient;
      ctx.fillRect(0, 0, width / 2, height / 2);

      // Ocean sphere with more realistic gradient
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      const oceanGradient = ctx.createRadialGradient(
        centerX - radius * 0.4,
        centerY - radius * 0.4,
        radius * 0.1,
        centerX,
        centerY,
        radius
      );
      oceanGradient.addColorStop(0, 'rgba(100, 200, 230, 0.3)');
      oceanGradient.addColorStop(0.3, 'rgba(50, 150, 200, 0.25)');
      oceanGradient.addColorStop(0.6, 'rgba(30, 100, 150, 0.2)');
      oceanGradient.addColorStop(1, 'rgba(10, 40, 80, 0.9)');
      ctx.fillStyle = oceanGradient;
      ctx.fill();

      // Globe border
      ctx.strokeStyle = 'rgba(55, 211, 255, 0.3)';
      ctx.lineWidth = 2;
      ctx.stroke();

      // Latitude lines
      for (let i = -2; i <= 2; i++) {
        ctx.beginPath();
        const y = centerY + (i * radius) / 3;
        const ellipseHeight = Math.sqrt(Math.max(0, radius * radius - ((i * radius) / 3) ** 2));
        ctx.ellipse(centerX, y, ellipseHeight, ellipseHeight / 4, 0, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.06)';
        ctx.lineWidth = 1;
        ctx.stroke();
      }

      // Longitude lines
      for (let i = 0; i < 8; i++) {
        const angle = (i * Math.PI) / 4 + (rotation.y * Math.PI / 180);
        ctx.beginPath();
        ctx.ellipse(centerX, centerY, Math.abs(Math.cos(angle)) * radius, radius, 0, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.06)';
        ctx.lineWidth = 1;
        ctx.stroke();
      }

      // Draw continents with more realistic land colors
      ctx.lineWidth = 1.5;
      
      worldMap.continents.forEach(continent => {
        ctx.beginPath();
        let firstPoint = true;
        
        const projectedPoints = continent.map(([lat, lon]) => 
          latLonToXY(lat, lon, centerX, centerY, radius, rotation.x, rotation.y)
        );
        
        // Check if any point is visible
        const hasVisiblePoints = projectedPoints.some(p => p.visible);
        
        if (hasVisiblePoints) {
          projectedPoints.forEach((point, idx) => {
            if (point.visible) {
              if (firstPoint) {
                ctx.moveTo(point.x, point.y);
                firstPoint = false;
              } else {
                ctx.lineTo(point.x, point.y);
              }
            }
          });
          ctx.closePath();
          
          // More realistic land color (earthy brown/green)
          ctx.fillStyle = 'rgba(80, 120, 80, 0.35)';
          ctx.fill();
          
          // Coastline border
          ctx.strokeStyle = 'rgba(120, 160, 120, 0.7)';
          ctx.stroke();
        }
      });

      // Vessel marker - centered on vessel location
      const vesselPos = latLonToXY(vesselData.lat, vesselData.lon, centerX, centerY, radius, rotation.x, rotation.y);
      
      // Draw vessel marker if visible
      if (vesselPos.visible) {
        // Vessel glow
        const glowGradient = ctx.createRadialGradient(vesselPos.x, vesselPos.y, 0, vesselPos.x, vesselPos.y, 15);
        glowGradient.addColorStop(0, 'rgba(55, 211, 255, 0.5)');
        glowGradient.addColorStop(1, 'transparent');
        ctx.fillStyle = glowGradient;
        ctx.beginPath();
        ctx.arc(vesselPos.x, vesselPos.y, 15, 0, Math.PI * 2);
        ctx.fill();

        // Vessel dot
        ctx.beginPath();
        ctx.arc(vesselPos.x, vesselPos.y, 6, 0, Math.PI * 2);
        ctx.fillStyle = '#37d3ff';
        ctx.fill();
        ctx.strokeStyle = 'rgba(55, 211, 255, 0.6)';
        ctx.lineWidth = 2;
        ctx.stroke();
      }

      // Layer overlays
      if (layers.depth) {
        const depthGradient = ctx.createRadialGradient(centerX, centerY, radius * 0.7, centerX, centerY, radius);
        depthGradient.addColorStop(0, 'rgba(24, 176, 166, 0)');
        depthGradient.addColorStop(1, 'rgba(24, 176, 166, 0.15)');
        ctx.fillStyle = depthGradient;
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.fill();
      }

      if (layers.temperature) {
        const tempGradient = ctx.createRadialGradient(centerX - 50, centerY - 50, 0, centerX, centerY, radius * 0.8);
        tempGradient.addColorStop(0, 'rgba(55, 211, 255, 0.2)');
        tempGradient.addColorStop(1, 'rgba(55, 211, 255, 0)');
        ctx.fillStyle = tempGradient;
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.fill();
      }
    };

    drawGlobe();
  }, [vesselData, layers, rotation]);

  // Mouse/touch drag handlers
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStart({
      x: e.clientX,
      y: e.clientY
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    
    const deltaX = e.clientX - dragStart.x;
    const deltaY = e.clientY - dragStart.y;
    
    setRotation(prev => ({
      x: prev.x + deltaY * 0.5,
      y: prev.y + deltaX * 0.5
    }));
    
    setDragStart({
      x: e.clientX,
      y: e.clientY
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Initialize globe centered on vessel location
  useEffect(() => {
    setRotation({
      x: 0,
      y: -vesselData.lon // Center on vessel longitude
    });
  }, []);

  return (
    <div 
      className="relative col-span-12 xl:col-span-7 rounded-lg overflow-hidden border border-border/70 bg-[radial-gradient(100%_140%_at_50%_0%,rgba(55,211,255,0.06),transparent_60%),hsl(var(--card))] shadow-ambient"
      style={{ height: 'min(62vh, 720px)' }}
      data-testid="globe-container"
    >
      <Badge 
        variant="outline" 
        className="absolute top-4 left-4 z-10 border-sky-400/30 text-sky-300 bg-sky-500/10"
        data-testid="globe-status-badge"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-sky-400 animate-pulse mr-1.5"></span>
        Live Tracking
      </Badge>

      <canvas 
        ref={canvasRef} 
        className="w-full h-full cursor-grab active:cursor-grabbing"
        data-testid="globe-canvas"
        role="img"
        aria-label={`3D globe showing vessel position at latitude ${vesselData.lat.toFixed(3)} degrees, longitude ${vesselData.lon.toFixed(3)} degrees, traveling at ${vesselData.speed.toFixed(1)} knots on heading ${Math.round(vesselData.heading)} degrees`}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      />

      <div 
        className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[rgba(6,10,18,0.85)] via-[rgba(6,10,18,0.4)] to-transparent p-5"
        data-testid="globe-overlay"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6 text-shadow-globe">
            <div className="font-mono text-sm">
              <span className="text-muted-foreground">LAT</span>{' '}
              <span className="text-primary" data-testid="globe-lat">{vesselData.lat.toFixed(3)}°</span>
            </div>
            <div className="font-mono text-sm">
              <span className="text-muted-foreground">LON</span>{' '}
              <span className="text-primary" data-testid="globe-lon">{vesselData.lon.toFixed(3)}°</span>
            </div>
            <div className="font-mono text-sm">
              <span className="text-muted-foreground">SPD</span>{' '}
              <span className="text-primary" data-testid="globe-speed">{vesselData.speed.toFixed(1)} kn</span>
            </div>
            <div className="font-mono text-sm">
              <span className="text-muted-foreground">HDG</span>{' '}
              <span className="text-primary" data-testid="globe-heading">{Math.round(vesselData.heading)}°</span>
            </div>
          </div>
          
          {/* Legend */}
          <div className="flex items-center gap-4 text-xs">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-cyan-400 border-2 border-cyan-400/60"></div>
              <span className="text-muted-foreground">Your Vessel</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-sm bg-emerald-400/20 border border-emerald-400"></div>
              <span className="text-muted-foreground">Continents</span>
            </div>
            <div className="text-muted-foreground">
              🖱️ Drag to rotate
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobeVisualization;
